{
  "v8e.lancements.liste.aucun_brouillon": "Aucune étape enregistrée",
  "v8e.lancements.liste.cree": "Créé par {{qui}} le {{depuis}}",
  "v8e.lancements.liste.membre": "Vous en êtes membre",
  "v8e.lancements.liste.non_membre": "Lancement de l’organisation : vous n’en êtes pas membre",
  "v8e.lancements.liste.pas": "Étape {{k}} sur {{total}} atteinte",
  "v8e.lancements.liste.programme": "programme {{nom}}",
  "v8e.lancements.liste.quoi": "les lancements à terminer",
  "v8e.lancements.liste.reprendre": "Reprendre le lancement de {{nom}}",
  "v8e.lancements.liste.resume": "{{n}} lancement(s) à terminer dans l’organisation, dont {{vous}} des vôtres.",
  "v8e.lancements.liste.vide": "Aucun lancement à terminer : tous les projets de l’organisation sont lancés.",
  "v8e.lancements.onglet.lancements": "Lancements à terminer ({{n}})",
  "v8e.lancements.onglet.projets": "Projets",
  "v8e.lancements.onglets": "Projets de l’organisation",
  "v8e.lancements.projet.ajouter": "Ajouter un composant",
  "v8e.lancements.projet.aucun_composant": "Aucun composant : ajoutez-en au moins un.",
  "v8e.lancements.projet.baseline_existante": "La baseline v{{v}} existe déjà.",
  "v8e.lancements.projet.baseline_v1_annoncee": "Terminer le lancement écrit la baseline technologique v1 ; elle ne changera ensuite que par une demande de changement.",
  "v8e.lancements.projet.brouillon_enregistre": "Brouillon enregistré.",
  "v8e.lancements.projet.composants": "Composants de l’application",
  "v8e.lancements.projet.composition_non_qualifiee": "Composition non qualifiée : {{motifs}}",
  "v8e.lancements.projet.composition_qualifiee": "Composition qualifiée.",
  "v8e.lancements.projet.deja_termine": "Lancement terminé : la baseline v1 existe.",
  "v8e.lancements.projet.demander_derogation": "Demander une dérogation",
  "v8e.lancements.projet.dialogue_non_disponible": "Ce dialogue n’est pas encore disponible dans cette version.",
  "v8e.lancements.projet.echec_brouillon": "Le brouillon n’a pas pu être enregistré ; rien n’a changé.",
  "v8e.lancements.projet.echec_fin": "Le lancement n’a pas pu être terminé ; aucune baseline n’a été écrite.",
  "v8e.lancements.projet.enregistrer": "Enregistrer le brouillon",
  "v8e.lancements.projet.enregistrer_quitter": "Enregistrer et quitter",
  "v8e.lancements.projet.etape.composition": "Composition technique",
  "v8e.lancements.projet.etape.recapitulatif": "Récapitulatif",
  "v8e.lancements.projet.etape.technologies": "Technologies par catégorie",
  "v8e.lancements.projet.etapes": "Étapes du lancement",
  "v8e.lancements.projet.inacheve": "Lancement inachevé : la génération et la livraison restent refusées jusqu’à sa fin.",
  "v8e.lancements.projet.mode.pile_prete": "Une pile prête à l’emploi",
  "v8e.lancements.projet.mode.sur_mesure": "Une application sur mesure (composants)",
  "v8e.lancements.projet.modele_sans_composition": "Le modèle de ce projet n’a pas d’application à composer.",
  "v8e.lancements.projet.modifier": "Modifier",
  "v8e.lancements.projet.piles": "les piles proposables",
  "v8e.lancements.projet.piles_vide": "Aucune pile proposable : le catalogue est vide, utilisez le jeu de départ.",
  "v8e.lancements.projet.plateforme": "Plateforme cible",
  "v8e.lancements.projet.plateforme_absente": "Le catalogue de l’organisation ne propose pas de plateforme cible.",
  "v8e.lancements.projet.plateforme_non_precisee": "Non précisée",
  "v8e.lancements.projet.plus_tard": "Plus tard",
  "v8e.lancements.projet.precedente": "Étape précédente",
  "v8e.lancements.projet.que_construisez_vous": "Que construisez-vous ?",
  "v8e.lancements.projet.quoi": "le lancement du projet",
  "v8e.lancements.projet.recapitulatif": "le récapitulatif",
  "v8e.lancements.projet.retirer": "Retirer {{role}}",
  "v8e.lancements.projet.retirer_consequence": "Ses liaisons sont retirées avec lui ; la qualification de la composition est recalculée.",
  "v8e.lancements.projet.retirer_titre": "Retirer le composant {{role}} ?",
  "v8e.lancements.projet.retirer_verbe": "Retirer",
  "v8e.lancements.projet.retour_projets": "Retour aux projets",
  "v8e.lancements.projet.role.donnees": "Données",
  "v8e.lancements.projet.role.interface": "Interface",
  "v8e.lancements.projet.role.service": "Service",
  "v8e.lancements.projet.role.service_de_plateforme": "Service de plateforme",
  "v8e.lancements.projet.suivante": "Suivant : {{nom}}",
  "v8e.lancements.projet.terminer": "Terminer le lancement",
  "v8e.lancements.projet.titre_etape": "Étape {{k}} sur {{total}} : {{nom}}",
  "v8e.lancements.raison.parametres": "Reprendre ce lancement demande « Modifier les paramètres du projet » sur ce projet ; le tient : {{detenteurs}}.",
  "v8e.lancements.raison.proprietaire_inconnu": "le propriétaire du projet"
}
